export default __webpack_public_path__ + "static/media/connection_icon_pending.eb0fcaaa.svg";